export const DeliveryPreferencesSelectors = {
  block: "DeliveryPreferences",
  label: "DeliveryPreferences__label",
  optionsContainer: "DeliveryPreferences__optionsContainer",
  toggle: "DeliveryPreferences__toggle",
  setByBuilding: "DeliveryPreferences__setByBuilding",
  leaveWaiverCheckbox: "DeliveryPreferences__leaveWaiverCheckbox",
  explanation: "DeliveryPreferences__explanation",
};
